import { CharacterUnlockData } from "../game/MissionsState";
import PlayerData from "../PlayerData";
import LoaderScene from "../scenes/LoaderScene";
import LoadBatches from "../utils/LoadBatches";
import GameConfig from "./data/GameConfig";
import LoadBatch from "./LoadBatch";

export default class LoadBatchManager {
    batches: Map<string, LoadBatch>;
    sceneBatches: Map<string, string>;

    constructor() {
        this.batches = new Map<string, LoadBatch>();
        this.sceneBatches = new Map<string, string>();
    }

    get(key: string): LoadBatch {
        if (!this.batches.has(key)) {
            const batch = new LoadBatch(key);
            this.batches.set(key, batch);
        }
        return this.batches.get(key);
    }

    setBatches(scene: string, batches: string): void {
        this.sceneBatches.set(scene, batches);
        console.log("set batches: " + scene + ", " + batches);
    }

    hasBatches(scene: string): boolean {
        return this.sceneBatches.has(scene);
    }

    getBatches(loaderScene: LoaderScene, destinationScene: string): LoadBatch[] {
        console.log("destination: " + destinationScene);
        const key = this.sceneBatches.get(destinationScene);
        console.log("key: " + key);
        return (<any>LoadBatchManager)[key](loaderScene);
    }

    loadBatchesForScene(loaderScene: LoaderScene, destinationScene: string): void {
        const batchesToLoad = this.getBatches(loaderScene, destinationScene);

        this.batches.forEach((batch: LoadBatch, _key: string): void => {
            if (batchesToLoad.find((b) => b == batch) == null) {
                batch.unload();
                if(batch.destroyOnUnload) this.batches.delete(_key);
            }
        });

        for (const batch of batchesToLoad) {
            batch.load(loaderScene);
        }
    }

    unloadAllBatches(): void {
        this.batches.forEach((batch: LoadBatch, _key: string): void => {
            if (!LoadBatchManager.GlobalBatches().includes(batch)) {
                batch.unload();
                if(batch.destroyOnUnload) this.batches.delete(_key);
            }
        });
    }

    private static GlobalBatches(): LoadBatch[] {
        const batches: LoadBatch[] = [];
        batches.push(LoadBatches.Global);
        batches.push(LoadBatches.Transition);
        return batches;
    }

    static MenuBatches(): LoadBatch[] {
        const batches: LoadBatch[] = [];
        batches.push(...this.GlobalBatches());
        batches.push(LoadBatches.Menu);
        return batches;
    }

    static GameplayBatches(): LoadBatch[] {
        const batches: LoadBatch[] = [];
        batches.push(...this.GlobalBatches());
        batches.push(LoadBatches.Gameplay);
        const currentCharacter = GameConfig.get<CharacterUnlockData[]>("characterUnlocks")[PlayerData.Instance.saveData.currentCharacter];
        const characterList = GameConfig.get<CharacterUnlockData[]>("characterUnlocks");
        const nextUnlockedCharacter = characterList[PlayerData.Instance.saveData.charactersUnlocked + 1];
        batches.push(LoadBatches.Character(currentCharacter));
        if(PlayerData.Instance.saveData.charactersUnlocked + 1 < characterList.length) batches.push(LoadBatches.UnlockedCharacter(nextUnlockedCharacter));
        return batches;
    }
}
